import { useNavigate, useSearchParams } from 'react-router'

export const getPublicCategories = categories =>
  categories.filter(({ isPublic }) => isPublic)

export const useKnowledgeBaseMenuNavigate = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const search = searchParams.get('kb_search')
  const query = search ? `?kb_search=${search}` : ''

  return path => {
    navigate({
      pathname: path,
      search: query,
    })
  }
}
